<script>
	import { onMount, setContext, tick } from 'svelte';
	import { L, key } from './leaflet.js';

	let container
	let map;

	export let lon;
	export let lat
	export let zoom;

	setContext(key, {
		getMap: () => map
	});

	onMount(() => {
		map = L.map(container).setView([lon,lat],zoom);
		let OpenStreetMap_Mapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(map);

				map.on("click",(e) => { console.log(e.latlng)});

		return () => {
			map.remove();
		};
	});

	$:
		if (map)
		{
			map.flyTo([lon,lat],zoom);
		}

</script>


<style>
    div{
        height:40rem;
    }
</style>

<div bind:this={container}>
	{#if map}
		<slot></slot>
	{/if}
</div>
